import { useMutation } from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import { eventsQueryKeys } from "features/events";
import { TransectionApiServices } from "features/transaction_list/api/transection-api.service";
import { queryClient } from "providers";

const { applyCouponBulk } = TransectionApiServices();

type ApplyBulkVariables = {
  payload: any;
  origin:string
  name: string; // dynamic endpoint part
  onSuccessCallback?: (couponAmount: number) => void;
};

export const useApplyCouponBulk = () => {
  const { message } = App.useApp();

  return useMutation(
    ({ payload, origin,name }: ApplyBulkVariables) => {
      return applyCouponBulk(payload,origin,name);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);
        message.error(uiMessage);
      },
      onSuccess: (data: any, variables: ApplyBulkVariables) => {
        if (
          variables?.onSuccessCallback &&
          data?.ResponseStatus === 1
        ) {
          variables.onSuccessCallback(data.couponAmount);
        }

        queryClient.invalidateQueries({
          queryKey: eventsQueryKeys.all,
        });
      },
    }
  );
};
